<template lang="html">
  <div>
    <Header currentMenu="Account" subMenu="Symbium Build" />
    <div class="dashboard-content-container gap-64">
      <div class="flex-box page-container">
        <Menu currentMenu="Symbium Build" class="desktop-only" />
        <div class="content">
          <div class="main-content">
            <div class="section">
              <h2 class="black bgap-48">Symbium Build</h2>
              <div v-if="loading">
                <div class="gap-3x" />
                <Spinner />
                <div class="gap-3x" />
              </div>
              <AlertSuccessModal :title="alertSucessMessage" />
              <div v-if="!loading">
                <div class="section-field bgap-48 flex-box wrap">
                  <h3 class="black pull-left bgap-24">General</h3>
                  <div class="field grey pull-right point-of-contact">
                    <div class="body-17-medium black bgap-32">Symbium Build users interested in your product(s) can contact you directly through the following Point of Contact Email address.  After that initial contact, you are free to communicate on any platform you like.</div>
                    <div class="user-infor-wrapper">
                      <div class="flex-box wrap user-info">
                        <SymbiumFormGroup
                          v-bind:value.sync="contact.firstName"
                          :error="errors.firstName"
                          label="First Name"
                          klass="bgap-24 hgap-32-right"
                        />
                        <SymbiumFormGroup
                          v-bind:value.sync="contact.lastName"
                          :error="errors.lastName"
                          label="Last Name"
                          klass="bgap-24"
                        />
                      </div>
                      <div class="flex-box wrap user-info">
                        <SymbiumFormGroup
                          v-bind:value.sync="contact.email"
                          :error="errors.email"
                          label="Email"
                          klass="bgap-24 hgap-32-right"
                        />
                        <SymbiumFormGroup
                          v-bind:value.sync="contact.phone"
                          :error="errors.phone"
                          label="Phone"
                          klass="bgap-24"
                        />
                      </div>
                      <div class="flex-box wrap">
                        <SymbiumButton
                          text="Save"
                          :onClick="submitData"
                          klass="small flex-box wrap"
                          :loading="submitting"
                          :isDisabled="!allowToSave"
                        />
                      </div>
                      <div class="flex-box wrap gap-12">
                        <Alert v-bind:message.sync="alertMessage" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FooterHelper />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegexValidation from 'src/mixins/RegexValidation.js'

import Header from 'src/components/dashboard/shares/Header.vue'
import Menu from 'src/components/dashboard/shares/Menu.vue'
import FooterHelper from 'src/components/dashboard/shares/FooterHelper.vue'
import EventBus from 'src/components/EventBus.js'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import Spinner from 'src/components/common/Spinner.vue'
import SymbiumFormGroup from 'src/components/common/form/SymbiumFormGroup.vue'
import Alert from 'src/components/common/Alert.vue'
import AlertSuccessModal from "src/components/common/modals/AlertSuccessModal.vue"

export default {
  components: { Alert, AlertSuccessModal, Header, Menu, SymbiumButton, FooterHelper, Spinner, SymbiumFormGroup },
  data() {
    return {
      submitting: false,
      loading: true,
      contact: {},
      vendorId: null,
      errors: {},
      alertSucessMessage: '',
      alertMessage: '',
      allowToSave: false,
    }
  },
  mixins: [RegexValidation],
  methods: {
    assignUserData(data) {
      this.contact = data.point_of_contact || {}
      this.vendorId = data.vendor_id
      this.loading = false
    },
    submitData() {
      this.submitting = true
      this.$vendor.updateVendorContact(
        this.vendorId, this.contact,
        () => { 
          this.submitting = false
          this.alertSucessMessage = "Point of Contact has been saved"
          this.$modal.show('alert-success-modal')
        },
        () => { this.submitting = false; this.alertMessage = "There is an error please try again!"; },
      )
    }
  },
  watch: {
    contact: {
      handler: function(val) {
        this.contact.name = `${val.firstName} ${val.lastName}`
        this.allowToSave = false
        
        if(this.validateEmail(this.contact.email)) {
          this.errors.email = null;
          if(this.contact.firstName && this.contact.lastName && this.contact.phone) 
            this.allowToSave = true
        } else {
          if (this.contact && this.contact.email) {
            this.errors.email = 'Invalid email address'
          }
        }
      },
      deep: true
    }
  },
  created() {
    EventBus.$on('user-fetched', this.assignUserData)
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignUserData)
  },
  mounted() {
    this.$user.fetchMe();
  },
}
</script>

<style lang="scss" scoped>
.menu-container, .content {
  height: fit-content;
  overflow-y: auto;
}

.user-infor-wrapper {
  width: fit-content;

  .user-info {
    justify-content: flex-start !important;
  }
}

.point-of-contact {
  .flex-box.wrap {
    height: auto;
    justify-content: space-evenly;

    &.save-contact {
      justify-content: center;
    }
  }
}
</style>
